export const BatteryIcon = ({
  width = '21',
  height = '17',
}: {
  width?: string;
  height?: string;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.9166 4.33339C20.9166 3.78085 20.6971 3.25095 20.3064 2.86025C19.9157 2.46955 19.3858 2.25006 18.8333 2.25006H16.7499V1.00006C16.7859 0.817783 16.7859 0.630246 16.7499 0.447972C16.6958 0.352138 16.6166 0.272898 16.5208 0.218806C16.3385 0.18287 16.1509 0.18287 15.9687 0.218806H13.4166C13.2343 0.18287 13.0468 0.18287 12.8645 0.218806C12.7687 0.272898 12.6894 0.352138 12.6353 0.447972C12.582 0.626824 12.5643 0.814393 12.5833 1.00006V2.25006H8.41659V1.00006C8.45252 0.817783 8.45252 0.630246 8.41659 0.447972C8.36249 0.352138 8.28325 0.272898 8.18742 0.218806C7.99209 0.158363 7.78605 0.140601 7.58325 0.166722H5.08325C4.90098 0.130787 4.71344 0.130787 4.53117 0.166722C4.43533 0.220815 4.35609 0.300055 4.302 0.395889C4.24156 0.591221 4.2238 0.797261 4.24992 1.00006V2.25006H2.16659C1.61405 2.25006 1.08415 2.46955 0.693446 2.86025C0.302745 3.25095 0.083252 3.78085 0.083252 4.33339V14.7501C0.083252 15.3026 0.302745 15.8325 0.693446 16.2232C1.08415 16.6139 1.61405 16.8334 2.16659 16.8334H18.8333C19.3858 16.8334 19.9157 16.6139 20.3064 16.2232C20.6971 15.8325 20.9166 15.3026 20.9166 14.7501V4.33339ZM8.93742 10.5834H7.37492V12.1459H5.29159V10.5834H3.72909V8.50006H5.29159V6.93756H7.37492V8.50006H8.93742V10.5834ZM16.7499 10.5834H12.5833V8.50006H16.7499V10.5834Z"
        fill="currentColor"
      />
    </svg>
  );
};
